import { QUESTIONS, QUESTIONS_PER_PAGE, TOTAL_PAGES } from "../../constants/questions.js";
import { BEHAVIORS, BEHAVIOR_MAP } from "../../constants/behaviors.js";
import { DOMAINS, DOMAIN_MAP, getDomain, NINEBOX_CELLS, COMPETENCIES } from "../../constants/competencies.js";

const PERF=["FT","LT","NNP","DP","ORG"], POT=["GA","A","NF","SR","E_W"];
const ALL=["T","LT","R_T","FT","RT","GA","SR","ORG","MT","DP","AC","E_W","NF","NA","NNP","A","S","F","P","O","R_R","T_R","CC","GF"];

function score(answers) {
  const raw={},cnt={};
  ALL.forEach(s=>{raw[s]=0;cnt[s]=0;});
  QUESTIONS.forEach((q,i)=>{
    if(!raw.hasOwnProperty(q.scale))return;
    cnt[q.scale]++;
    if(q.keyed===1&&answers[i]==="A")raw[q.scale]++;
    if(q.keyed===-1&&answers[i]==="D")raw[q.scale]++;
  });
  const norm={};
  ALL.forEach(sc=>{norm[sc]=Math.max(1,Math.min(10,Math.round((raw[sc]/(cnt[sc]||1))*9)+1));});
  const vf=raw["GF"]>6?"HIGH":raw["GF"]===0?"LOW":null;
  const perfAvg=+(PERF.reduce((s,k)=>s+(norm[k]||5),0)/PERF.length).toFixed(1);
  const potAvg=+(POT.reduce((s,k)=>s+(norm[k]||5),0)/POT.length).toFixed(1);
  const perfBox=perfAvg<=4?1:perfAvg<=7?2:3;
  const potBox=potAvg<=4?1:potAvg<=7?2:3;
  return{scales:norm,raw,validityFlag:vf,perfAvg,potAvg,perfBox,potBox,axes:{x:perfAvg,y:potAvg}};
}

function buildAIPrompt(a,type){
  const s=a.scores||{},overall=+(Object.values(s).filter(n=>typeof n==="number").reduce((a,b,_,arr)=>a+b/arr.length,0)).toFixed(1);
  const cell=NINEBOX_CELLS.find(c=>c.x===a.perfBox&&c.y===a.potBox);
  const lines=BEHAVIORS.map(b=>{const v=s[b.id];if(!v)return null;return`  • ${b.name}(${b.code}):${v}/10[${v<=3?"LOW":v>=8?"HIGH":"MID"}]`;}).filter(Boolean).join("\n");
  return`Expert occupational psychologist interpreting ASSESS Survey.\n${type==="hiring"?"HIRING REPORT":"DEVELOPMENT REPORT"}\nCandidate:${a.name}|${a.role}|${a.demo?.country||""}\nOverall:${overall}/10|9-Box:${cell?.label||"—"}\nScales:\n${lines}`;
}

export default{
  id:"assess",name:"ASSESS Personality Survey",shortName:"ASSESS",
  version:"3.1",publisher:"Assess Systems™",
  description:"350-item personality survey measuring 24 bipolar scales across Thinking, Working and Relating domains.",
  icon:"⚙",color:"#1d4ed8",bg:"#dbeafe",
  totalQuestions:350,timeEstimate:"30–40 min",scaleType:"agree-disagree",
  pagesOf:QUESTIONS_PER_PAGE,totalPages:TOTAL_PAGES,
  questions:QUESTIONS,scales:BEHAVIORS,scaleMap:BEHAVIOR_MAP,
  domains:DOMAINS,domainMap:DOMAIN_MAP,getDomain,
  nineboxAxes:{x:{label:"Performance",description:"Current role effectiveness",scaleIds:PERF},y:{label:"Potential",description:"Growth trajectory",scaleIds:POT}},
  nineboxCells:NINEBOX_CELLS,competencies:COMPETENCIES,
  score,buildAIPrompt,
  answerFormat:{type:"binary",options:[{value:"A",label:"Agree",color:"#1d4ed8"},{value:"D",label:"Disagree",color:"#ef4444"}]},
};
